import { render, staticRenderFns } from "./SidebarAnchor.vue?vue&type=template&id=4d2cf62f&"
import script from "./SidebarAnchor.vue?vue&type=script&lang=js&"
export * from "./SidebarAnchor.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAnchor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports